module.exports = __webpack_public_path__ + "static/media/visa.c8a22efd.svg";